import React, { useState, useEffect } from 'react';

export default function AwardsStrip() {
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(localStorage.getItem('awards_dismissed_v1') !== '1'); }, []);
  if (!show) return null;
  return (
    <div className="aw-strip" data-testid="awards-strip"><div className="wrap">
      <span><span className="s">✦</span> Proudly a <b>2026 Finalist</b> · The Local Business Awards — <a href="/awards">Read the story →</a></span>
      <button className="x" aria-label="Dismiss" data-testid="awards-dismiss" onClick={() => { localStorage.setItem('awards_dismissed_v1', '1'); setShow(false); }}>&times;</button>
    </div></div>
  );
}
